"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var component_list_cell_1 = __importDefault(require("@doordash/component-list-cell"));
var React = __importStar(require("react"));
var enums_1 = require("../Common/utils/enums");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("./TwoFactorAuthenticationStrings"));
var TwoFactorAuthenticationUtils_1 = require("./TwoFactorAuthenticationUtils");
var VerifyAccountStyles_1 = require("./VerifyAccountStyles");
var HelpDropdown = function (_a) {
    var generatePasscode = _a.generatePasscode, blockChannelSwitch = _a.blockChannelSwitch, channel = _a.channel, trackChannelSwitch = _a.trackChannelSwitch, trackHelpClick = _a.trackHelpClick, closeDropdown = _a.closeDropdown;
    return (React.createElement(VerifyAccountStyles_1.DropdownContainer, null,
        React.createElement(component_list_cell_1["default"], { href: TwoFactorAuthenticationUtils_1.HELP_LINK, onClick: function () {
                trackHelpClick();
                closeDropdown();
            }, tag: "a", target: "_blank", title: TwoFactorAuthenticationStrings_1["default"].contactSupport() }),
        !blockChannelSwitch && (React.createElement(component_list_cell_1["default"], { onClick: function () {
                generatePasscode(channel === enums_1.TwoFactorChannels.SMS
                    ? enums_1.TwoFactorChannels.Email
                    : enums_1.TwoFactorChannels.SMS);
                trackChannelSwitch();
                closeDropdown();
            }, title: channel === enums_1.TwoFactorChannels.SMS
                ? TwoFactorAuthenticationStrings_1["default"].sendCodeToEmail()
                : TwoFactorAuthenticationStrings_1["default"].sendCodeToPhone() }))));
};
exports["default"] = HelpDropdown;
